import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon';

export const Copy = Styled(
	createSvgIcon(
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M13.3327 10.7503V14.2503C13.3327 17.167 12.166 18.3337 9.24935 18.3337H5.74935C2.83268 18.3337 1.66602 17.167 1.66602 14.2503V10.7503C1.66602 7.83366 2.83268 6.66699 5.74935 6.66699H9.24935C12.166 6.66699 13.3327 7.83366 13.3327 10.7503Z'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M18.3327 5.75033V9.25033C18.3327 12.167 17.166 13.3337 14.2494 13.3337H13.3327V10.7503C13.3327 7.83366 12.166 6.66699 9.24935 6.66699H6.66602V5.75033C6.66602 2.83366 7.83268 1.66699 10.7493 1.66699H14.2494C17.166 1.66699 18.3327 2.83366 18.3327 5.75033Z'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>,
		'Eye'
	)
);

export default Copy;
